export const SYNCED_ACCOUNT_PERMISSIONS = {
  // Google and Microsoft scopes
  PROFILE: 'profile',
  CALENDAR: 'calendar',
  CONTACTS: 'contacts',
  CHAT: 'chat',

  // Zoom scopes
  USER: 'user',
  MEETING: 'meeting',
  RECORDING: 'recording',
  USER_PROFILE: 'user_profile',
  WEBINAR_TOKEN: 'webinar_token',
  MEETING_TOKEN: 'meeting_token',
} as const;

export type SyncedAccountPermission =
  (typeof SYNCED_ACCOUNT_PERMISSIONS)[keyof typeof SYNCED_ACCOUNT_PERMISSIONS];
